import {
  RESOURCE_TYPE_ATTR_TRANSFORM,
  RESOURCE_TYPE_CREDENTIAL_GROUP,
  RESOURCE_TYPE_CREDENTIALS,
  RESOURCE_TYPE_DATA_MAP,
  RESOURCE_TYPE_DATA_SET,
  RESOURCE_TYPE_RECORD_TRANSFORM,
  RESOURCE_TYPE_SINK,
  RESOURCE_TYPE_SOURCE,
} from 'js/constants/resourceTypes';
import useEntities from 'new/state/entities/repository/useEntities';

function getEntityName(data, resourceType) {
  if (resourceType) {
    switch (resourceType) {
      case RESOURCE_TYPE_SOURCE:
        return 'sources';

      case RESOURCE_TYPE_SINK:
        return 'sinks';

      case RESOURCE_TYPE_DATA_SET:
        return 'dataSets';
      case RESOURCE_TYPE_CREDENTIALS:
        return 'credentials';

      case RESOURCE_TYPE_DATA_MAP:
        return 'dataMaps';

      case RESOURCE_TYPE_RECORD_TRANSFORM:
      case RESOURCE_TYPE_ATTR_TRANSFORM:
        return 'transforms';
      default:
        return null;
    }
  }

  if (data?.type) {
    switch (data?.type) {
      case 'SOURCE':
        return 'sources';

      case RESOURCE_TYPE_CREDENTIAL_GROUP:
        return 'credentialsGroups';

      case 'DATA_SINK':
        return 'sinks';

      case 'DATA_SET':
        return 'dataSets';
      case RESOURCE_TYPE_CREDENTIALS:
        return 'credentials';

      case RESOURCE_TYPE_DATA_MAP:
        return 'dataMaps';

      case RESOURCE_TYPE_RECORD_TRANSFORM:
      case RESOURCE_TYPE_ATTR_TRANSFORM:
        return 'transforms';
      default:
        return null;
    }
  }

  switch (data?.resourceType) {
    case RESOURCE_TYPE_CREDENTIALS:
      return 'credentials';

    case RESOURCE_TYPE_DATA_MAP:
      return 'dataMaps';

    case RESOURCE_TYPE_RECORD_TRANSFORM:
    case RESOURCE_TYPE_ATTR_TRANSFORM:
      return 'transforms';

    default:
      return null;
  }
}

export default function useResourceEntity(data, resourceType = undefined) {
  const entityName = getEntityName(data, resourceType);
  return useEntities(`${entityName}[${data?.id}]`)?.data;
}
